/**
 * Helper to resolve a cocktail's image URL.
 * Priority:
 *   1. cocktail.afbeelding if it is an absolute URL or data:image
 *   2. fallback unsplash photo
 */
const FALLBACK = 'https://images.unsplash.com/photo-1772661515640-0f205cbf6796?w=800&h=600&fit=crop';

export const cocktailImageUrl = (cocktail) => {
  const v = (cocktail?.afbeelding || '').trim();
  if (!v) return FALLBACK;
  if (v.startsWith('http://') || v.startsWith('https://') || v.startsWith('data:image')) {
    return v;
  }
  return FALLBACK;
};
